import styled from '@emotion/styled';
import { B400, R400, N20 } from '@atlaskit/theme/colors';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const LoadingSkeleton = styled.div({
  backgroundColor: `var(--ds-surface, ${`${N20}`})`,
  height: '16px',
  width: '128px',
  borderRadius: '3px'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const TextLabelWrapper = styled.span({
  color: `var(--ds-text-accent-red, ${`${R400}`})`,
  fontSize: '12px'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const TextCorrectionWrapper = styled.a({
  cursor: 'pointer',
  color: `var(--ds-text-accent-blue, ${`${B400}`})`,
  fontSize: '12px'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const AutocorrectWrapper = styled.div({
  textTransform: 'initial',
  fontWeight: 'initial'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const NoResultsAutocorrectWrapper = styled.div({
  marginTop: "var(--ds-space-100, 8px)",
  fontSize: '12px',
  marginLeft: "var(--ds-space-200, 16px)"
});